<template>
  <div>
    <el-form class="form" label-width="100px" ref="ruleForm" :model="form" :rules="rules">
      <el-form-item label="用户ID：" prop="userIds">
        <el-input
          v-model="form.userIds"
          type="textarea"
          rows="6"
          resize="none"
          placeholder="请输入用户ID，多个用 ' , ' 分隔（最多100个）"
        />
      </el-form-item>
      <el-form-item label="俱乐部ID：" prop="clubId">
        <el-input class="club_id" v-model="form.clubId" placeholder="请输入" />
        <div class="club_name common-text-ellipsis" v-text="`俱乐部昵称：${clubName}`"></div>
      </el-form-item>
      <el-form-item label="推广员：" prop="promotorText">
        <el-input v-model="form.promotorText" disabled style="width: 360px" placeholder="请选择">
          <el-popover
            v-model="popoverValue"
            slot="append"
            placement="right"
            width="400"
            trigger="click"
          >
            <el-button
              :disabled="!this.form.clubId"
              slot="reference"
              style="color: #333"
              @click="getList()"
            >
              选择
            </el-button>
            <div class="common-search">
              <el-input
                v-model="searchVal"
                style="width: 200px !important"
                class="common-el-input-small"
                size="mini"
              />
              <el-button @click="getList()" type="primary" size="mini">搜索 </el-button>
            </div>
            <el-table
              v-loading="loading"
              :data="promotorInfos.beanList"
              height="400px"
              row-key="userId"
              @row-click="selectPromotor"
            >
              <el-table-column align="center" label="编号" type="index" />
              <el-table-column align="center" label="推广员ID" prop="userId" />
              <el-table-column align="center" label="推广员昵称" prop="userName" />
            </el-table>
            <el-pagination
              class="common-el-pagination"
              layout="prev,pager,next"
              :pager-count="5"
              :page-size="10"
              :total="promotorInfos.total"
              :current-page="currentPage"
              @current-change="getList($event)"
            />
          </el-popover>
        </el-input>
        <el-button style="float: right" type="primary" @click="submitForm('ruleForm')"
          >加入</el-button
        >
      </el-form-item>
    </el-form>
    日志输出
    <p v-show="successUsers.length" class="tip">
      成功加入俱乐部的用户名单:
      <span v-for="(item, index) of successUsers" :key="item">
        <template v-if="index !== 0">,</template>{{ item }}
      </span>
    </p>
    <p v-show="failUsers.length" class="tip">
      没有加入俱乐部的用户名单:
      <span v-for="(item, index) of failUsers" :key="item"
        ><template v-if="index !== 0">,</template>{{ item }}</span
      >
    </p>
    <p v-show="notExistUsers.length" class="tip">
      不存在的用户名单:
      <span v-for="(item, index) of notExistUsers" :key="item"
        ><template v-if="index !== 0">,</template>{{ item }}</span
      >
    </p>
    <p v-show="alreadyInClubUsers.length" class="tip">
      已经在俱乐部的用户名单:
      <span v-for="(item, index) of alreadyInClubUsers" :key="item"
        ><template v-if="index !== 0">,</template>{{ item }}</span
      >
    </p>
    <p v-show="promotorUsers.length" class="tip">
      是推广员的用户名单:
      <span v-for="(item, index) of promotorUsers" :key="item"
        ><template v-if="index !== 0">,</template>{{ item }}</span
      >
    </p>
    <p v-show="createClubUsers.length" class="tip">
      创建俱乐部的用户名单:
      <span v-for="(item, index) of createClubUsers" :key="item"
        ><template v-if="index !== 0">,</template>{{ item }}</span
      >
    </p>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      promotorInfos: {
        // 推广员列表
        beanList: [],
        total: 0,
      },
      currentPage: 1,
      clubName: '', // 俱乐部昵称
      searchVal: '', // 推广员搜索
      promotorId: '', // 推广员ID
      popoverValue: false,
      form: {
        userIds: '',
        clubId: '',
        promotorText: '',
      },
      rules: {
        userIds: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.split(',').length > 100) {
                callback(new Error('用户ID最多100个'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        clubId: [{ required: true, message: '请输入俱乐部ID', trigger: 'blur' }],
        promotorText: [{ required: true, message: '请选择推广员', trigger: 'blur' }],
      },
      failUsers: [],
      successUsers: [],
      notExistUsers: [],
      alreadyInClubUsers: [],
      promotorUsers: [],
      createClubUsers: [],
    };
  },
  methods: {
    ...mapActions('club', ['getClubPromoters', 'batchJoinClub']),
    getList(page = 1) {
      this.loading = true;
      this.currentPage = page;
      this.getClubPromoters({
        clubId: this.form.clubId,
        search: this.searchVal,
        page,
        size: 10,
      }).then((res) => {
        this.loading = false;
        this.clubName = res.data.clubName;
        this.promotorInfos = res.data.promotorInfos;
      });
    },
    selectPromotor(row) {
      this.form.promotorText = `${row.userName}(ID：${row.userId})`;
      this.promotorId = row.userId;
      this.popoverValue = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.batchJoinClub({
            clubId: this.form.clubId,
            promotorId: this.promotorId,
            userIds: this.form.userIds,
          }).then((res) => {
            this.$message.success('请求成功');
            this.successUsers = res.data.successUsers;
            this.failUsers = res.data.failUsers;
            this.notExistUsers = res.data.notExistUsers;
            this.alreadyInClubUsers = res.data.alreadyInClubUsers;
            this.promotorUsers = res.data.promotorUsers;
            this.createClubUsers = res.data.createClubUsers;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  padding: 5px 30px;
  font-size: 14px;
  color: #666;
}

.form {
  width: 550px;
  :global(.el-button) {
    width: 80px;
  }
}

.club_id {
  display: inline-block;
  width: 180px;
  vertical-align: middle;
}

.club_name {
  display: inline-block;
  width: 260px;
  margin-left: 10px;
  vertical-align: middle;
}
</style>
